import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteSaint, getSaint, restoreSaint, updateSaint } from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditSaint() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateSaint(id, title, description, image);
      if (result) {
        navigate("/saint/all");
      }
    } catch (error) {}
  };

  const publishSaint = async (id) => {
    try {
      await restoreSaint(id);

      navigate("/saint/all");
    } catch (error) {}
  };
  const unPublishSaint = async (id) => {
    try {
      await deleteSaint(id);

      navigate("/saint/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneSaint = async (id) => {
    try {
      const result = await getSaint(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.saintId}
          breadCrumbLink={"Saint"}
          breadCrumbText={"Edit News"}
          goBackLink={"/saint/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishSaint}
          unPublishItem={unPublishSaint}
          getOneItem={getOneSaint}
        />
      </Container>
    </>
  );
}
